import React from "react";
import { MdAddPhotoAlternate } from "react-icons/md";

type AddMediaButtonProps = {
  onClick: () => void;
};

const AddMediaButton: React.FC<AddMediaButtonProps> = ({ onClick }) => {
  return (
    <li className="flex-shrink-0">
      <button
        onClick={onClick}
        className="w-[100px] h-[100px] flex items-center justify-center bg-antd-colorBgContainerDisabled hover:bg-antd-colorBgContainer text-antd-colorTextSecondary hover:text-antd-colorText border border-dashed border-antd-colorBorder rounded cursor-pointer transition-colors"
        aria-label="Add media"
        type="button"
      >
        <MdAddPhotoAlternate size={24} />
      </button>
    </li>
  );
};

export default AddMediaButton;
